import React from 'react';
import { Separator } from '../Separator/Separator';
import { FaRegCheckCircle } from 'react-icons/fa';
import { TiWarningOutline } from 'react-icons/ti';
import { FiInfo } from 'react-icons/fi';
import { MdCancel } from 'react-icons/md';
import { Button } from '../Button/Button';

function WarningDeleteImg({ onClose, message, isError = false, isInfo = false }) {
  return (
    <div className="flex flex-col gap-2">
      {isError && (
        <>
          <div className="flex w-full flex-col items-center justify-center">
            <TiWarningOutline
              size={90}
              className="text-yellow-600"
            />
            <h2 className="font-bold">GAGAL</h2>
          </div>
        </>
      )}
      {!isError && !isInfo && (
        <>
          <div className="flex w-full flex-col items-center justify-center">
            <FaRegCheckCircle
              size={88}
              className="py-1 text-green-500"
            />
            <h2 className="font-bold">BERHASIL</h2>
          </div>
        </>
      )}
      {isInfo && !isError && (
        <>
          <div className="flex w-full flex-col items-center justify-center">
            <FiInfo
              size={90}
              className="py-1 text-gray-500"
            />
            <h2 className="font-bold">INFORMASI</h2>
          </div>
        </>
      )}
      <div className="flex flex-col gap-2">
        <p className="text-wrap whitespace-normal text-center font-normal">{message}</p>
      </div>
      <Separator className="mb-1 bg-gray-600" />
      <div className="flex items-center justify-center">
        <Button
          name="cancel"
          onClick={onClose}
          className="bg-gray-600 text-white hover:bg-gray-700"
        >
          {isInfo ? (
            <span className="px-2">OK</span>
          ) : (
            <>
              <MdCancel size={18} />
              &nbsp;Close
            </>
          )}
        </Button>
      </div>
    </div>
  );
}

export default WarningDeleteImg;
